import ReportDetail from '@components/common/ReportDetails';
import ErrorBoundary from '@components/ErrorBoundary';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import { useSingleInterview } from '@hooks/getQueries';
import usePermission from '@hooks/usePermission';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

export default function InterviewReportDetails() {
  const { id } = useParams();
  const { data: interview } = useSingleInterview(id);

  const {
    data: { studyPermission },
    isPending,
  } = usePermission({ study: interview });

  return (
    <PageContainer title={'Interview | Custom Reports'}>
      <Suspense fallback={<Spinner isPending={isPending} />}>
        <ErrorBoundary>
          <ReportDetail canEdit={studyPermission?.edit} />
        </ErrorBoundary>
      </Suspense>
    </PageContainer>
  );
}
